// @flow weak
import auth from '../services/auth';
export const appConfig     = require('../../../appConfig');

export const headerConfig = {
  headerDatas: { 
    'Content-Type': 'application/json',
    'secretkey': appConfig.site.secret_key,
    'Access-Control-Allow-Origin':'*',
  },
  headerImage: { 
  	cache: false,
    contentType: false,
    processData: false,
    'secretkey': appConfig.site.secret_key,
  }
};

export const refineHeader = function() {
  let token=auth.getToken();
  if(token!=''){
     headerConfig.headerDatas["Authorization"] = 'Bearer ' + token;
     headerConfig.headerImage["Authorization"] = 'Bearer ' + token;
  }
};


// WEBPACK FOOTER //
// ./src/app/config/headerConfig.js